import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button type="button" aria-label="Remonter en haut de la page" title="Haut de page"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed right-5 md:right-10 bottom-28 z-[90] w-11 h-11 grid place-items-center bg-black/80 backdrop-blur border border-white/20 text-zinc-200 hover:bg-primary hover:border-primary hover:text-white transition-[opacity,transform,background-color] duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
      data-testid="back-to-top-button">
      <ArrowUp className="w-4 h-4" />
    </button>
  );
};
